import EditIncomeAssetsModalContainer from "./EditIncomeAssetsModalContainer";

export default EditIncomeAssetsModalContainer;
